import type { TRPCClient } from '@trpc/client';
import { createTRPCOptionsProxy } from '@trpc/tanstack-react-query';
import type { TRPCOptionsProxy } from '@trpc/tanstack-react-query';

import { queryClient } from '@/utils/trpc';
import type { AppRouter } from '@infinex/main-service-contract/v2/client';
import {
  createMainServiceTrpcClient,
  type MainServiceTrpcClient as Client,
} from '@infinex/user';

import { WORKER_MAIN_PROXY_PATH } from './environment/config';

export type { Client };
export const client = createMainServiceTrpcClient({
  url: `${WORKER_MAIN_PROXY_PATH}/v2`,
});

export const trpcClientV2 = createTRPCOptionsProxy<AppRouter>({
  client,
  queryClient,
});

export const initializeClients = (): {
  client: Client;
  apiClientV2: TRPCClient<AppRouter>;
  trpcClientV2: TRPCOptionsProxy<AppRouter>;
} => {
  return { client, apiClientV2: client, trpcClientV2 };
};
